import React from 'react';
import { useRouteMatch, Switch, Route, useParams } from 'react-router-dom';
import Map from './map';
import MapboxMap from './mapbox_map'
import List from './list';
import MuseumDetail from './detail';
import MuseumEdit from '../Admin/Museum/edit-museum';
import Initial_detail from './initial_detail'

function Museum(){
    let {path, url} = useRouteMatch()

    return(
        <div className='flex_museum'>
            <div id='museum_left'>
                <Route  path={`${url}/list/:tag`}><List/></Route>
            </div>

            <div id='museum_right'>
                <Switch >
                 <Route path={`${url}/list/all/detail/upcoming/:id`}><MuseumDetail/></Route>
                 <Route path={`${url}/list/all/detail/:id`} ><MuseumDetail/></Route>
                 <Route path={`${url}/list/photograph/detail/upcoming/:id`}><MuseumDetail/></Route>
                 <Route path={`${url}/list/photograph/detail/:id`} ><MuseumDetail/></Route>
                 <Route path={`${url}/list/applied_fine_arts/detail/upcoming/:id`}><MuseumDetail/></Route>
                 <Route path={`${url}/list/applied_fine_arts/detail/:id`} ><MuseumDetail/></Route>
                 <Route path={`${url}/list/ancient_art/detail/upcoming/:id`}><MuseumDetail/></Route>
                 <Route path={`${url}/list/ancient_art/detail/:id`} ><MuseumDetail/></Route>
                 <Route path={`${url}/list/classic_art/detail/upcoming/:id`}><MuseumDetail/></Route>
                 <Route path={`${url}/list/classic_art/detail/:id`} ><MuseumDetail/></Route>
                 <Route path={`${url}/list/modern_art/detail/upcoming/:id`}><MuseumDetail/></Route>
                 <Route path={`${url}/list/modern_art/detail/:id`} ><MuseumDetail/></Route>
                 <Route path={`${url}/list/contemporary_art/detail/upcoming/:id`}><MuseumDetail/></Route>
                 <Route path={`${url}/list/contemporary_art/detail/:id`} ><MuseumDetail/></Route>
                 <Route path={`${url}/list/isRecommendation/detail/upcoming/:id`}><MuseumDetail/></Route>
                 <Route path={`${url}/list/isRecommendation/detail/:id`} ><MuseumDetail/></Route>
                 <Route path={`${url}/list/isFreeAdmission/detail/upcoming/:id`} ><MuseumDetail/></Route>
                 <Route path={`${url}/list/isFreeAdmission/detail/:id`} ><MuseumDetail/></Route>
                 <Route path={`${url}/list/isOpenMonday/detail/upcoming/:id`} ><MuseumDetail/></Route>
                 <Route path={`${url}/list/isOpenMonday/detail/:id`} ><MuseumDetail/></Route>
                 <Route path={`${url}/list/open_museum/detail/upcoming/:id`} ><MuseumDetail/></Route>
                 <Route path={`${url}/list/open_museum/detail/:id`} ><MuseumDetail/></Route>
                 <Route path={`${url}/list/close_museum/detail/upcoming/:id`} ><MuseumDetail/></Route>
                 <Route path={`${url}/list/close_museum/detail/:id`} ><MuseumDetail/></Route>
                </Switch>
            </div> 
        </div>
    )
}

export default Museum;